var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"popup-close-button",on:{"click":_vm.closePopup}},[_c('span',{staticClass:"popup-close-button-box"})])}
var staticRenderFns = []

export { render, staticRenderFns }